import clsx from "clsx";
import { ArrowsUpDownIcon } from "@heroicons/react/24/solid";
import { useBreakpointContext } from "@/contexts/BreakpointContext";
import { Select, type Option } from "@/components/ui/Select";
import BottomSheet, { useBottomSheet } from "@/components/ui/bottomSheet";
import { SortOptions } from "@/constants/enums";

const orderbyOptions: Option[] = [
  { value: SortOptions.DEFAULT, label: "預設排序" },
  {
    value: SortOptions.DATE,
    label: "最新商品",
  },
  {
    value: SortOptions.POPULARITY,
    label: "最熱銷",
  },
  {
    value: SortOptions.PRICE_ASC,
    label: "價格：低到高",
  },
  {
    value: SortOptions.PRICE_DESC,
    label: "價格：高到低",
  },
];

interface OrderSelectorProps {
  orderBy: SortOptions;
  onOrderChange: (value: SortOptions) => void;
}

const ProductOrderSelector = ({ orderBy, onOrderChange }: OrderSelectorProps) => {
  const { isMobile, isTablet } = useBreakpointContext();
  const productSortSheet = useBottomSheet();

  const handleOrderSelect = (optionValue: SortOptions) => {
    onOrderChange(optionValue);
    productSortSheet.handleClose();
  };

  if (isMobile || isTablet) {
    return (
      <>
        <div className="relative inline-flex items-center gap-1">
          <button
            type="button"
            className="btn btn-outline btn-sm font-normal"
            onClick={productSortSheet.handleOpen}
          >
            {orderbyOptions.find((option) => option.value === orderBy)?.label || "預設排序"}
            <ArrowsUpDownIcon className="size-4" />
          </button>
        </div>
        <BottomSheet
          show={productSortSheet.isOpen}
          title="排序"
          onClose={productSortSheet.handleClose}
        >
          <OrderbyMobileMenu orderBy={orderBy} onOrderChange={handleOrderSelect} />
        </BottomSheet>
      </>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <ArrowsUpDownIcon className="size-5 text-secondary" />
      <Select
        name="productOrderBy"
        options={orderbyOptions}
        value={orderBy}
        onSelectChange={onOrderChange}
      />
    </div>
  );
};

const OrderbyMobileMenu = ({
  orderBy,
  onOrderChange,
}: {
  orderBy: SortOptions;
  onOrderChange: (optionValue: SortOptions) => void;
}) => (
  <div className="flex flex-col gap-6 lg:gap-2">
    {orderbyOptions.map((option) => {
      const isChecked = orderBy === option.value;

      return (
        <label key={option.value} className="flex items-center justify-between gap-2">
          <span className="cursor-pointer">{option.label}</span>
          <input
            type="radio"
            name="productOrderBy"
            value={option.value}
            checked={isChecked}
            onChange={() => onOrderChange(option.value as SortOptions)}
            className={clsx(
              "radio-secondary radio radio-sm self-end",
              !isChecked ? "opacity-20" : "",
            )}
          />
        </label>
      );
    })}
  </div>
);

export default ProductOrderSelector;
